var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1757"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20A10.01 10.01 0 0 1 0 10 10.01 10.01 0 0 1 10 0a10.01 10.01 0 0 1 10 10 10.01 10.01 0 0 1-10 10M5 9v3h10V9Z",
    "data-name": "Exclusion 42"
  }))));
};
export default SvgError;